export const assertKitchenResponse = (response) => {
  const data = response?.data;
  if (!response || [data, data?.data, data?.data?.data].some((value) =>
    value?.es > 0 || value?.success === false || ["ERROR", "FAILED", "FAILURE"].includes(value?.status)
  )) {
    throw new Error(data?.message || data?.data?.message || "The kitchen update failed.");
  }
  return response;
};

export const isLiveTask = (task) =>
  !!task &&
  !["COMPLETED", "REMOVED", "CANCELLED", "CANCELED", "REJECTED"].includes(task?.taskStatus) &&
  !["COMPLETED", "REMOVED", "CANCELLED", "CANCELED", "REJECTED"].includes(task?.status);

/** Revalidate selections against freshly fetched jobs before writing. */
export const performKitchenAction = async ({ kind, entries, jobs, updateJobs, updateTaskStatus, audit }) => {
  const selectedByJob = new Map();
  const expected = kind === "start" ? "PENDING" : "IN_PROGRESS";
  (entries || []).forEach((entry) => {
    const job = jobs.find((candidate) => candidate.jobId === entry.orderId);
    const task = job?.tasks?.find((candidate) => candidate.taskId === entry.taskId);
    if (!entry.taskId || !task || !isLiveTask(task) || job.status !== expected ||
      (kind === "ready" && task.status && task.status !== "IN_PROGRESS")) return;
    if (kind === "ready" && entry.quantity != null && Number(entry.quantity) !== Number(task.quantity)) return;
    if (!selectedByJob.has(job.jobId)) selectedByJob.set(job.jobId, new Set());
    selectedByJob.get(job.jobId).add(task.taskId);
  });
  if (!selectedByJob.size) {
    throw new Error("These items have changed or are no longer eligible. Refresh and select them again.");
  }
  const selectedOrders = [...selectedByJob.keys()];
  if (kind === "start") {
    assertKitchenResponse(await updateJobs({
      ...audit, jobIds: selectedOrders, status: "IN_PROGRESS",
    }));
    return { succeeded: selectedOrders, failed: [], skipped: entries.filter((entry) =>
      !selectedByJob.get(entry.orderId)?.has(entry.taskId)).length };
  }
  const results = await Promise.allSettled(selectedOrders.map(async (jobId) =>
    assertKitchenResponse(await updateTaskStatus({
      ...audit, jobId, taskIds: [...selectedByJob.get(jobId)], status: "COMPLETED",
    }))
  ));
  return {
    succeeded: selectedOrders.filter((id, index) => results[index].status === "fulfilled"),
    failed: selectedOrders.filter((id, index) => results[index].status === "rejected"),
    skipped: entries.filter((entry) => !selectedByJob.get(entry.orderId)?.has(entry.taskId)).length,
  };
};
